/**
 * @flow
 * @format
 */

import { combineReducers } from 'redux';
import { reducer as notifReducer } from 'redux-notifications';

// import { reducers } from '../modules';
import modalReducer from './modal';
import designReducer from './design';
import progressReducer from './progress';
import errorReducer from './errors';
import globalReducer from './global';

export default combineReducers({
  modals: modalReducer,
  notifs: notifReducer,
  errors: errorReducer,
  global: globalReducer,
  design: designReducer,
  progress: progressReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js